import { render, staticRenderFns } from "./partnerAdmin.vue?vue&type=template&id=15adf376&scoped=true&"
import script from "./partnerAdmin.vue?vue&type=script&lang=js&"
export * from "./partnerAdmin.vue?vue&type=script&lang=js&"
import style0 from "./partnerAdmin.vue?vue&type=style&index=0&id=15adf376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15adf376",
  null
  
)

export default component.exports